<template>
<div>
  <div style="text-align: left">
    <el-form size="small" style="margin: 20px 0 0" :model="serviceInfo" ref="serviceInfo" :rules="handleFormRules" label-width="90px" class="demo-ruleForm my-form">
      <el-row>
        <el-col :span="12" style="padding-right: 10px;box-sizing: border-box">
          <el-form-item label="订单号" prop="">
            <div class="inpt-form"><span>{{ serviceInfo.orderid }}</span></div>
          </el-form-item>
          <el-form-item label="服务内容" prop="">
            <div class="inpt-form"><span>{{serviceInfo.service_name}}</span></div>
          </el-form-item>
          <el-form-item label="服务时间" prop="">
<!--            <el-date-picker v-fixZoom v-if="orderObj.type === 'log'" v-model="serviceInfo.begin_time" type="datetime" :clearable="false" class="my-form-inpt"-->
<!--                            placeholder="请选择" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%" default-time="08:00:00">-->
<!--            </el-date-picker>-->
            <div class="inpt-form">
              <span v-if="serviceInfo.startDay">{{serviceInfo.startDay}}</span>
              <span style="margin-left: 5px" v-if="serviceInfo.week">{{serviceInfo.week}}</span>
              <span style="margin-left: 5px" v-if="serviceInfo.startTime">{{serviceInfo.startTime}}</span>
            </div>
          </el-form-item>
          <el-form-item label="服务时长" prop="times1">
<!--            <el-input v-if="orderObj.type === 'log'" class="my-form-inpt" type="number" placeholder="请输入"-->
<!--                      v-model="serviceInfo.times1">-->
<!--              <template slot="append">分钟</template>-->
<!--            </el-input>-->
            <div class="inpt-form"><span v-if="serviceInfo.tmShow">{{serviceInfo.tmShow}}</span></div>
          </el-form-item>
          <el-form-item label="服务地址" prop="">
            <div class="inpt-form">{{ serviceInfo.backup_address }}<span v-if="serviceInfo.backup_address === ''">{{serviceInfo.home_address}}</span></div>
          </el-form-item>
        </el-col>
        <el-col :span="12" style="padding-left: 10px;box-sizing: border-box">
          <el-form-item label="服务对象" prop="">
            <div class="inpt-form"><span>{{ serviceInfo.person_name }}</span></div>
          </el-form-item>
          <el-form-item label="性别" prop="">
            <div class="inpt-form"><span v-if="serviceInfo.person_sex === 0">女</span><span v-if="serviceInfo.person_sex === 1">男</span></div>
          </el-form-item>
          <el-form-item label="年龄" prop="">
            <div class="inpt-form"><span>{{ serviceInfo.age }}</span></div>
          </el-form-item>
          <el-form-item label="联系电话" prop="">
            <div class="inpt-form">{{ serviceInfo.backup_phone }}<span v-if="serviceInfo.backup_phone === ''">{{serviceInfo.person_phone}}</span></div>
          </el-form-item>
          <el-form-item label="发起备注" prop="">
            <div class="inpt-form">{{ serviceInfo.pps_remark }}</div>
          </el-form-item>
        </el-col>
      </el-row>
      <!--  拓展字段  -->
      <el-row>
        <el-col :span="12" v-for="(item, index) in serviceList" :key="index" style="box-sizing: border-box" :style="{paddingLeft: index % 2 === 0 ? '' : '10px', paddingRight: index % 2 === 0 ? '10px' : ''}">
          <div style="height: 50px">
            <div style="height: 32px;line-height:32px;font-size:14px;text-align:center;width: 90px;float: left;color: #ffffff;background: #3D83F3;
                border-radius: 5px 5px 5px 5px;"><span>{{item.key}}</span></div>
            <div style="height: 32px;line-height:32px;width: calc(100% - 100px);margin-left: 10px;float: left">
              <div class="inpt-form"><span>{{ item.value }}</span></div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div class="blue-line-h"></div>
    <div class="handle-title">服务过程记录</div>
    <el-form v-if="orderObj.type === 'order' || orderObj.type === 'log'" size="small" style="margin: 20px 0 0"
             :model="serviceInfo" ref="serviceInfo" :rules="handleFormRules" label-width="90px" class="demo-ruleForm my-form">
      <el-row>
        <el-col :span="12" style="padding-right: 10px;box-sizing: border-box">
          <el-form-item label="服务提供商" prop="">
            <div class="inpt-form"><span>{{serviceInfo.supplier_name}}</span></div>
          </el-form-item>
          <el-form-item label="开始时间" prop="start_svs_tm">
<!--            <el-date-picker v-fixZoom v-if="orderObj.type === 'log'" v-model="serviceInfo.start_svs_tm" type="datetime" :clearable="false" class="my-form-inpt"-->
<!--                            placeholder="请选择" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%" default-time="08:00:00">-->
<!--            </el-date-picker>-->
            <div class="inpt-form">
              <span v-if="serviceInfo.startDay1">{{serviceInfo.startDay1}}</span>
              <span style="margin-left: 5px" v-if="serviceInfo.week1">{{serviceInfo.week1}}</span>
              <span style="margin-left: 5px" v-if="serviceInfo.startTime1">{{serviceInfo.startTime1}}</span>
            </div>
          </el-form-item>
          <el-form-item label="完成地址" prop="">
            <div class="inpt-form"><span>{{serviceInfo.service_address}}</span></div>
          </el-form-item>
        </el-col>
        <el-col :span="12" style="padding-left: 10px;box-sizing: border-box">
          <el-form-item label="服务人员" prop="">
            <div class="inpt-form"><span>{{serviceInfo.supplier_person_name}}</span></div>
          </el-form-item>
          <el-form-item label="完成时长" prop="times">
<!--            <el-input v-if="orderObj.type === 'log'" class="my-form-inpt" type="number" placeholder="请输入"-->
<!--                      v-model="serviceInfo.times">-->
<!--              <template slot="append">分钟</template>-->
<!--            </el-input>-->
            <div class="inpt-form"><span>{{serviceInfo.tmShow1}}</span></div>
          </el-form-item>
          <el-form-item label="服务备注" prop="">
            <div class="inpt-form"><span>{{serviceInfo.remark}}</span></div>
          </el-form-item>
        </el-col>
      </el-row>
      <!--  拓展字段  -->
      <el-row>
        <el-col :span="12" v-for="(item, index) in sureArr" :key="index" style="box-sizing: border-box" :style="{paddingLeft: index % 2 === 0 ? '' : '10px', paddingRight: index % 2 === 0 ? '10px' : ''}">
          <div style="height: 50px">
            <div style="height: 32px;line-height:32px;font-size:14px;text-align:center;width: 90px;float: left;color: #ffffff;background: #3D83F3;
                border-radius: 5px 5px 5px 5px;"><span>{{item.key}}</span></div>
            <div style="height: 32px;line-height:32px;width: calc(100% - 100px);margin-left: 10px;float: left">
              <div class="inpt-form"><span>{{ item.value }}</span></div>
            </div>
          </div>
        </el-col>
      </el-row>
      <!--  拓展照片  -->
      <el-row>
        <el-col :span="24" v-for="(item, index) in pictureArr" :key="index" style="margin-bottom: 20px">
          <div style="height: 150px">
            <div style="height: 150px;line-height:32px;font-size:14px;text-align:center;width: 90px;float: left;color: #ffffff;background: #3D83F3;
                border-radius: 5px 5px 5px 5px;"><span>{{item.key}}</span></div>
            <div style="width: calc(100% - 90px);float: left;height: 150px;background: #EBF2FA;border-radius: 5px 5px 5px 5px;">
              <div class="inpt-form" style="padding: 15px 0;box-sizing: border-box"><img @click="getBigImg(item.uri)" class="picture" v-if="item.uri && item.uri !== ''" :src="item.uri" /></div>
            </div>
          </div>
        </el-col>
      </el-row>
      <!--  服务照片  -->
      <el-row>
<!--        <el-col :span="24" v-if="orderObj.type === 'log'">-->
<!--          <div style="height: 123px">-->
<!--            <div style="height: 123px;line-height:32px;font-size:14px;text-align:center;width: 90px;float: left;color: #ffffff;background: #3D83F3;-->
<!--                border-radius: 5px 5px 5px 5px;"><span>其他照片</span></div>-->
<!--            <div style="width: calc(100% - 100px);margin-left: 10px;height: 123px;float: left;background: #FFFFFF;border-radius: 5px 5px 5px 5px;box-sizing: border-box;border: 1px solid #3D83F3">-->
<!--              <div class="inpt-form" style="padding: 15px 0 0 10px;box-sizing: border-box;background: #FFFFFF;">-->
<!--                <el-upload class="upload-img1" action="#" list-type="picture-card" accept=".png,.jpg,jpeg"-->
<!--                           :auto-upload="false" :on-preview="handlePictureCardPreview"-->
<!--                           :on-remove="handleRemove1" :on-success="handleSuccess" :on-error="handleError"-->
<!--                           :on-change="handleChange1" :limit="10" :file-list="dialogImageUrlArray1" ref="upload1">-->
<!--                  <i class="el-icon-plus"></i>-->
<!--                </el-upload>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </el-col>-->
        <el-col :span="24">
          <div style="height: 150px">
            <div style="height: 150px;line-height:32px;font-size:14px;text-align:center;width: 90px;float: left;color: #ffffff;background: #3D83F3;
                border-radius: 5px 5px 5px 5px;"><span>其他照片</span></div>
            <div style="width: calc(100% - 90px);height: 150px;float: left;background: #EBF2FA;border-radius: 5px 5px 5px 5px;">
              <div class="inpt-form" style="padding: 15px 0;box-sizing: border-box"><img @click="getBigImg(item.uri)" class="picture" v-for="(item, index) in serviceInfo.serviceImg" :key="index" :src="item.uri" />
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row v-if="orderObj.type === 'log'" style="margin-top: 20px">
        <el-col :span="12" style="padding-right: 10px;box-sizing: border-box">
          <el-form-item label="审核结果" prop="">
            <div class="inpt-form">
              <span v-if="serviceInfo.is_tag === 1">待确认</span>
              <span v-if="serviceInfo.is_tag === 2">待完成</span>
              <span v-if="serviceInfo.is_tag === 3">待审核</span>
              <span v-if="serviceInfo.is_tag === 4">审核失败</span>
              <span v-if="serviceInfo.is_tag === 5">已完成</span>
              <span v-if="serviceInfo.is_tag === 6">已关闭</span>
              <span v-if="serviceInfo.is_tag === 7">已反馈审核</span>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" style="padding-left: 10px;box-sizing: border-box">
          <el-form-item label="审核备注" prop="">
            <div class="inpt-form"><span>{{serviceInfo.checkinfo_remark}}</span></div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
<!--    <div style="height: 50px" v-if="orderObj.type === 'log'">-->
<!--      <el-row style="margin: 0 30px">-->
<!--        <el-col :span="12">-->
<!--          <div class="cancel-btn1" @click="closeOpen()"><span>取消</span></div>-->
<!--        </el-col>-->
<!--        <el-col :span="12">-->
<!--          <div class="send-btn1" @click="submitHandle('serviceInfo')"><span>确定修改</span></div>-->
<!--        </el-col>-->
<!--      </el-row>-->
<!--    </div>-->
  </div>
  <el-dialog width="750px" :visible.sync="showImg" v-if="showImg" :close-on-click-modal="true" append-to-body class="all-open">
    <div style="text-align: center;padding: 30px 0;">
      <img style="max-width: 700px" :src="showUrl">
    </div>
  </el-dialog>
</div>
</template>

<script>
import {queryfileurl} from '../../../api/service'
import {uploadfile} from '../../../api/yanglaoyuan'
import {updatepersonsupplierservicerecordsbasic} from '../../../api/serviceMark'

export default {
  name: 'orderContent',
  props: {
    orderObj: {
      type: Object
    }
  },
  data () {
    return {
      orderInfo: '',
      serviceInfo: {
        person_name: '',
        service_name: '',
        person_sex: '',
        age: '',
        begin_time: '',
        end_time: '',
        pps_remark: '',
        home_address: '',
        service_address: '',
        remark: '',
        serviceImg: [],
        times1: '', // 服务时长
        start_svs_tm: '', // 开始时间
        svs_tm: '', // 完成时间
        service_img: '', // 其他照片id
        times: 60 // 完成时长
      },
      // 拓展字段
      serviceList: [],
      sureArr: [],
      pictureArr: [],

      showImg: false,
      showUrl: '',
      handleFormRules: {
        supplier_org_id: [{ required: true, message: '请选择服务商', trigger: 'change' }],
        start_svs_tm: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
        times1: [{ required: true, message: '请输入服务时长', trigger: 'change' }],
        times: [{ required: true, message: '请输入完成时长', trigger: 'change' }],
        service_address: [{ required: true, message: '请输入完成地址', trigger: 'blur' }]
      },
      dialogImageUrlArray1: []
    }
  },
  created () {
    this.getInfo()
  },
  methods: {
    getInfo () {
      let obj = this.clone(this.orderObj.row)
      console.log(obj)
      obj.tmShow = ''
      obj.times1 = ''
      if (obj.begin_time !== '') {
        obj.startDay = obj.begin_time.split(' ')[0]
        let tm = obj.begin_time.split(' ')[1]
        obj.startTime = tm.split(':')[0] + ':' + tm.split(':')[1]
        obj.week = this.util.getWeekDay(obj.begin_time)
        obj.tmShow = this.util.getTimeDifference(obj.begin_time, obj.end_time)

        let startTime = new Date(obj.begin_time) // 开始时间
        let endTime = new Date(obj.end_time) // 结束时间
        let usedTime = endTime - startTime // 相差的毫秒数
        let hours = Math.floor(usedTime / (60 * 1000)) // 相差的分钟数
        obj.times1 = hours
        console.log('服务时长', obj.times1)
      }
      obj.tmShow1 = ''
      if (obj.start_svs_tm && obj.start_svs_tm !== '0000-00-00 00:00:00' && obj.svs_tm && obj.svs_tm !== '0000-00-00 00:00:00') {
        obj.startDay1 = obj.start_svs_tm.split(' ')[0]
        let tm1 = obj.start_svs_tm.split(' ')[1]
        obj.startTime1 = tm1.split(':')[0] + ':' + tm1.split(':')[1]
        obj.week1 = this.util.getWeekDay(obj.start_svs_tm)
        obj.tmShow1 = this.util.getTimeDifference(obj.start_svs_tm, obj.svs_tm)

        let startTime = new Date(obj.start_svs_tm) // 开始时间
        let endTime = new Date(obj.svs_tm) // 结束时间
        let usedTime = endTime - startTime // 相差的毫秒数
        let hours = Math.floor(usedTime / (60 * 1000)) // 相差的分钟数
        obj.times = hours
        console.log('完成时长', obj.times)
      }
      obj.age = this.getAgeDesc(obj.birthday)
      obj.servicerequirements = this.orderObj.type === 'orderHandle' ? obj.servicerequirements : [[], []]
      obj.pictureArr = []
      if (this.orderObj.type !== 'orderHandle' && obj !== '') {
        try {
          obj.servicerequirements = JSON.parse(obj.service_requirements)
          obj.pictureArr = JSON.parse(obj.picture_requirements)
        } catch (error) {}
      }
      obj.serviceInfo = []
      obj.serviceImg = []
      this.serviceInfo = obj
      let listIds = []
      if (this.orderObj.type !== 'orderHandle' && obj.service_img !== '') {
        let ids = obj.service_img.split(',')
        ids.forEach(item => {
          listIds.push(parseInt(item))
        })
      }
      if (listIds.length > 0) {
        let data = {
          fileids: listIds
        }
        queryfileurl(data).then(res => {
          let imgs = []
          let fileurls = res.data.fileurls
          fileurls.forEach(item => {
            let url = item.uri
            if (window.location.host === 'kangnh.com') {
              let uris = item.uri.split('/api/v1/web/')
              url = 'https://kangnh.com/api/v1/web/' + uris[1]
            }
            item.uri = url
            item.url = url
            item.fileid = item.id
            imgs.push(item)
          })
          obj.serviceImg = imgs
          // if (window.location.host === 'kangnh.com') {
          //   let imgs = []
          //   let fileurls = res.data.fileurls
          //   fileurls.forEach(item => {
          //     let uris = item.uri.split('/api/v1/web/')
          //     let url = 'https://kangnh.com/api/v1/web/' + uris[1]
          //     item.uri = url
          //     imgs.push(item)
          //   })
          //   obj.serviceImg = imgs
          // } else {
          //   obj.serviceImg = res.data.fileurls
          // }
          this.dialogImageUrlArray1 = obj.serviceImg
          this.serviceInfo = obj
          console.log('其他照片1', this.serviceInfo.serviceImg)
        })
      }
      this.serviceList = obj.servicerequirements[0]
      this.sureArr = obj.servicerequirements[1]
      this.pictureArr = obj.pictureArr
      let pictIds = []
      obj.pictureArr.forEach(item => {
        if (item.value !== '') {
          pictIds.push(parseInt(item.value))
        }
      })
      if (pictIds.length > 0) {
        this.getPicture(pictIds)
      }
      // console.log(this.orderObj.type === 'orderHandle', this.serviceList)
    },
    getAgeDesc (birthDate) {
      let result = ''
      let age = this.util.getAgeByBirth(birthDate)
      if (age === '') {
        result = '--'
      } else {
        result = age + '岁'
      }
      return result
    },
    getPicture (ids) {
      console.log('ids', ids)
      let data = {
        fileids: ids
      }
      queryfileurl(data).then(res => {
        res.data.fileurls.forEach(item => {
          this.pictureArr = this.pictureArr.map(val => {
            if (item.id === parseInt(val.value)) {
              if (window.location.host === 'kangnh.com') {
                let uris = item.uri.split('/api/v1/web/')
                let url = 'https://kangnh.com/api/v1/web/' + uris[1]
                val.uri = url
              } else {
                val.uri = item.uri
              }
            }
            return val
          })
        })
        console.log(998877, this.pictureArr)
      })
    },
    getBigImg (url) {
      this.showUrl = url
      this.showImg = true
    },

    // 上传图片
    handlePictureCardPreview (file) {
      this.getBigImg(file.url)
    },
    handleSuccess (res, file, fileList) {
      this.$message.success('上传成功')
    },
    // eslint-disable-next-line handle-callback-err
    handleError (err, file, fileList) {
      this.$message.error('上传失败')
    },
    // 服务照片
    handleRemove1 (file, fileList) {
      for (let i = 0; i < this.dialogImageUrlArray1.length; i++) {
        if (this.dialogImageUrlArray1[i].url === file.url) {
          this.dialogImageUrlArray1.remove(this.dialogImageUrlArray1[i])
        }
      }
    },
    handleChange1 (file, fileList) {
      let types = ['image/png', 'image/jpeg', 'image/jpg']
      if (types.indexOf(file.raw.type) === -1) {
        this.$message.error('上传头像图片只能是 .png .jpeg .jpg 格式!')
        return
      }
      let obj = {
        raw: file.raw,
        filename: '服务照片',
        domain: window.location.host.indexOf('localhost') === 0 ? 'https://jiaold.com' : window.location.protocol + '//' + window.location.host
      }
      this.$message({message: '正在上传。', type: 'warning', duration: 0})
      uploadfile(obj).then(res => {
        this.$message.closeAll()
        this.$message({ message: '成功上传图片', type: 'success' })
        file.filename = res.data.filename
        file.fileid = res.data.fileid
        this.dialogImageUrlArray1.push(file)
        console.log(this.dialogImageUrlArray1)
      }).catch(() => {
        this.$message.closeAll()
        this.$refs.upload1.uploadFiles = this.dialogImageUrlArray1
        this.$message({ message: '上传图片失败', type: 'error' })
      })
    },

    closeOpen () {
      this.$emit('closeOrder')
    },
    submitHandle (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let startTime1 = new Date(this.serviceInfo.begin_time).getTime()
          let endTime1 = 60 * 1000 * parseFloat(this.serviceInfo.times1)

          let startTime = new Date(this.serviceInfo.start_svs_tm).getTime()
          let endTime = 60 * 1000 * parseFloat(this.serviceInfo.times)
          // eslint-disable-next-line no-extend-native
          Date.prototype.format = this.validate.format
          const date1 = new Date(endTime1 + startTime1).format('yyyy-MM-dd hh:mm:ss')
          const date = new Date(endTime + startTime).format('yyyy-MM-dd hh:mm:ss')
          console.log(date)
          let data = {
            id: this.orderObj.row.id,
            begin_time: this.serviceInfo.begin_time,
            end_time: date1,
            start_svs_tm: this.serviceInfo.start_svs_tm,
            svs_tm: date,
            service_img: this.dialogImageUrlArray1.map(item => item.fileid).join(',')
          }
          console.log(data, this.dialogImageUrlArray1)
          updatepersonsupplierservicerecordsbasic(data).then(res => {
            this.$message.success('提交成功')
            this.closeOpen()
          }).catch(err => {
            console.log(err)
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.text-top{
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #3D83F3;
}
.circle-center{
  display: flex;
  padding: 6px 0;
}
.img-left{
  text-align: center;
  width: 90px;
  height: 32px;
}
.blue-line{
  margin-top: 16px;
  height: 1px;
  background: #3D83F3;
  border-radius: 0px 0px 0px 0px;
  flex: 1;
}
.time-bottom{
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #3D83F3;
}
.blue-line-h{
  height: 1px;
  background: #3D83F3;
  border-radius: 4px 4px 4px 4px;
}
.handle-title{
  margin-top: 20px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 22px;
  color: #3D3D3D;
}
.picture{
  width: 120px;
  height: 120px;
  background-color: #00b0c0;border-radius: 6px 6px 6px 6px;
  cursor: pointer;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/servicemanagement/childComponents/orderContent.vue